export default __webpack_public_path__ + "static/devops-1f1c58701995d2f98e112b62dc3fe841.png";